/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Calendar_More_CountInputs */

const cs_calendar_more_count = /** @type {(inputs: Calendar_More_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} další`)
};

const en_calendar_more_count = /** @type {(inputs: Calendar_More_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} more`)
};

/**
* | output |
* | --- |
* | "+{count} more" |
*
* @param {Calendar_More_CountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_more_count = /** @type {((inputs: Calendar_More_CountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_More_CountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_more_count(inputs)
	return cs_calendar_more_count(inputs)
});